export var LinkState;
(function (LinkState) {
    LinkState["READY"] = "ready";
    LinkState["STARTING"] = "starting";
    LinkState["FINISHED"] = "finished";
})(LinkState || (LinkState = {}));
export var LabProviders;
(function (LabProviders) {
    LabProviders["SKILLABLE"] = "skillable";
})(LabProviders || (LabProviders = {}));
export var ExamProviders;
(function (ExamProviders) {
    ExamProviders["KAPLAN"] = "kaplan";
})(ExamProviders || (ExamProviders = {}));
export var LinkType;
(function (LinkType) {
    LinkType["TEXT"] = "text";
    LinkType["LAB"] = "lab";
    LinkType["EXAM"] = "exam";
    LinkType["META"] = "meta";
})(LinkType || (LinkType = {}));
export var LinkAction;
(function (LinkAction) {
    LinkAction["DEFAULT"] = "default";
    LinkAction["EMBED"] = "embed";
    LinkAction["BLANK"] = "blank";
})(LinkAction || (LinkAction = {}));
//# sourceMappingURL=types.js.map